import { render, staticRenderFns } from "./ServicePortal.vue?vue&type=template&id=87db5e08&scoped=true"
import script from "./ServicePortal.vue?vue&type=script&lang=js"
export * from "./ServicePortal.vue?vue&type=script&lang=js"
import style0 from "./ServicePortal.vue?vue&type=style&index=0&id=87db5e08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87db5e08",
  null
  
)

export default component.exports